<template>
  <div id="app" style="height: 100%">
<!--    <router-view v-wechat-title='$route.meta.title'></router-view>-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" ></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" ></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="less">
  #nprogress .bar {
    background: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue